function CarConfigurationViewController(
  userViewService,
  trainService,
  eventService,
  CommonService,
  $interval,
  $filter,
  $stateParams,
  $state,
  $scope
) {
  const ctrl = this;

  ctrl.$onInit = () => {
    $scope.view = 'car';
    userViewService.setView('carView');
    CommonService.setConsist($stateParams.trainId);
    ctrl.consist = $stateParams.trainId;
    ctrl.train =  CommonService.getSelectedTrain();
    CommonService.setSelectedCar($stateParams.carNumber);
    ctrl.carNumber = $stateParams.carNumber;

    if (!ctrl.train) {
      ctrl.loadTrain();
    }
    ctrl.lastLoad = DateTime.now();
    ctrl.startDataReceivedRefresher();
    ctrl.eventListener();
  };

  ctrl.$onDestroy = () => {
    // Clear the Car filter on exit
    CommonService.setSelectedCar(null);
    $interval.cancel(ctrl.dataReceivedRefreshPromise);
  };

  ctrl.startDataReceivedRefresher = () => {
    ctrl.dataReceivedRefreshPromise = $interval(ctrl.refreshDataReceived, 1000);
  };

  ctrl.refreshDataReceived = () => {
    if (ctrl.train.status) {
      ctrl.sinceDataReceived = $filter('secondsAgoUTC')(ctrl.train.status.dataReceived);
    }
  };

  ctrl.eventListener = () => {
    const unbind = eventService.on('FLEET_STATUS', () => {
      if (ctrl.lastLoad.diffNow('seconds').seconds < -3) {
        ctrl.loadTrain();
        ctrl.lastLoad = DateTime.now();
      }
    });
    $scope.$on('$destroy', unbind);
  };

  ctrl.loadTrain = async () => {
    trainService
      .get(ctrl.consist)
      .then((data) => {
        if (!data) {
          ctrl.connectionStatusToTrain = false;
        } else {
          ctrl.connectionStatusToTrain = true;
          if (!angular.equals(ctrl.train, data)) {
            ctrl.train = data;
            ctrl.lastLoad = DateTime.now();
          }
          data = null;
          ctrl.sinceDataReceived = $filter('secondsAgoUTC')(ctrl.train.status.dataReceived);
        }
      })
      .catch(error => {
      });
  };

  ctrl.goBack = () => {
    const previousView = userViewService.getPreviousView();
    if (previousView === 'configuration') {
      $state.go('train', { consist:ctrl.consist });
    } else {
      $state.go(userViewService.getPreviousView());
    }
  };

  ctrl.getReturnButtonText = () => {
    const previousView = userViewService.getPreviousView();
    if (previousView === 'configuration') {
      return 'train';
    } else {
      return 'dashboard';
    }
  };
}

angular
  .module('configuration-management.module')
  .controller('CarConfigurationViewController', CarConfigurationViewController);
